import { createContext, use } from 'react';

import { useScrollTo } from '@/hooks/scroll';

import type { ScrollContextType, ScrollProviderProps } from '.';

const ScrollContext = createContext<ScrollContextType | null>(null);

export function ScrollProvider(scrollProviderProps: ScrollProviderProps) {
  const { children, options = {} } = scrollProviderProps;
  const scrollToHook = useScrollTo(options);

  return <ScrollContext value={scrollToHook}>{children}</ScrollContext>;
}

export function useScrollContext(): ScrollContextType {
  const context = use(ScrollContext);
  if (!context) {
    throw new Error('useScrollContext must be used within a ScrollProvider');
  }
  return context;
}
